import {Nullish} from 'shared/web';

export type ReceiveNoteBasicInformationReadOnlyFields = {
  supplierName: string | Nullish;
  warehouseName: string | Nullish;
  authorizationProfileName: string | Nullish;
  number: string | Nullish;
  date: string | Nullish;
  invoiceNumber: string | Nullish;
  invoiceIssueDate: string | Nullish;
  paymentType: string | Nullish;
  currency: string | Nullish;
  exchangeRate: number | Nullish;
  ncConversion: string | Nullish;
  note: string | Nullish;
  createdDate?: string | Nullish;
  updatedDate?: string | Nullish;
  completedDate?: string | Nullish;
  deliveryNoteNumber?: string | Nullish;
  issuedAt?: string | Nullish;
};
